








































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import MpUserInfoApi from "@/api/wechat/mpUserInfo/index";
import DateFormat from "dateformat";
import AbpBase from "@/lib/abpbase";
import CustomForm from "@/components/custom-form/index.vue";

@Component({
  components: {
    CustomForm
  }
})
export default class MpUserList extends AbpBase {
  loading = false;
  pager = {
    pageIndex: 1,
    pageSize: 10,
    total: 0
  };
  filters = [
    {
      label: "店铺编码",
      type: "input",
      props: {
        placeholder: "请输入店铺编码"
      },
      key: "ShopCode"
    },
    {
      label: "通过店铺关注",
      type: "select",
      props: {
        placeholder: "请选择"
      },
      key: "FromShop",
      options: [
        {
          text: "是",
          value: "true"
        },
        {
          text: "否",
          value: "false"
        }
      ]
    }
  ];
  columns1 = [
    {
      title: "头像",
      key: "headImgUrl",
      slot: "headImgUrl",
      width: 80
    },
    {
      title: "昵称",
      key: "nickName"
    },
    {
      title: "性别",
      key: "sex",
      slot: "sex"
    },
    {
      title: "关注",
      key: "subscribe",
      slot: "subscribe"
    },
    {
      title: "关注时间",
      key: "subscribeTime",
      slot: "subscribeTime"
    },
    {
      title: "是否通过店铺关注",
      key: "fromShop",
      slot: "fromShop"
    },
    {
      title: "店铺编码",
      key: "shopCode"
    }
  ];
  data1 = [];

  mounted() {
    this.loadData();
  }
  onPageIndexChange(value) {
    this.pager.pageIndex = value;
    let form = (this.$refs.lineForm as any).form;
    this.loadData(form);
  }
  submitChange(form, valid) {
    if (valid) {
      this.loadData(form);
    }
  }
  loadData(form = {}) {
    this.loading = true;
    let fromShop = form["FromShop"];
    let shopCode = form["ShopCode"];
    MpUserInfoApi.getList(
      this.pager.pageSize,
      this.pager.pageIndex,
      null,
      fromShop,
      shopCode
    ).then(res => {
      this.pager.total = res.data.totalCount;
      this.data1 = res.data.items;
      this.loading = false;
    });
  }
}
